import axios from "axios";
import functions from "../functions";
import config from "../config";

export default class WebsiteService {
  fetchIrinoxNews(locale) {
    const language = functions.newsLanguages(locale);

    if (process.env.NODE_ENV === 'development') {
      if (config.currentEnv != 'prod') {
        return axios.get('/stubs/website_news_dev.json?language=' + language).then(res => res.data);
      } else {
        return axios.get('/stubs/website_news_prod.json?language=' + language).then(res => res.data);
      }
    }

    let url = 'https://api.irinoxprofessional.com/graphql';
    if (config.currentEnv != 'prod') {
      url = 'https://staging.api.irinoxprofessional.we-dev.it/graphql';
    }

    const headers = {
      'content-type': 'application/json',
    };

    const data = {
      operationName: "NEWS_INDEX_DATA",
      query: `query NEWS_INDEX_DATA($site: [String], $category: [String], $offset: Int, $limit: Int) {
        articles: entries(
          section: "news"
          offset: $offset
          limit: $limit
          relatedToCategories: [{slug: $category, site: $site}]
          orderBy: "dateCreated DESC"
          site: $site
        ) {
          ... on news_Entry {
            id
            title
            slug
            uri
            shortDescription
            abstract
            category: newsCategory {
              title
            }
            date: postDate
            coverImage {
              id
              src: url
              webp: url(format: "webp")
              avif: url(format: "avif")
              width
              height
              hasFocus: hasFocalPoint
              focus: focalPoint
              ... on AssetInterface {
                alt
              }
            }
          }
        }
        total: entryCount(
          section: "news"
          relatedToCategories: [{slug: $category, site: $site}]
          orderBy: "dateCreated DESC"
          site: $site
        )
      }`,
      variables: {
        offset: 0,
        limit: 10,
        site: language
      }
    };
    return axios.post(url, data, { headers })
      .then(res => res.data);
  }
}
